interface WindowWithJquery extends Window {
  jQuery: {
    fn: {
      focus: () => void
    }
  }
}

export function init(w: Window): w is WindowWithJquery {
  return !!(w as WindowWithJquery).jQuery
}

export const disableJqueryFocus = () => {
  if (!init(window)) {
    return
  }

  ;($ => {
    $.fn.focus = () => {}
  })(window.jQuery)
}
